import React from 'react';
import styled from 'styled-components';

const ReviewLeftComponent = () => (
  <ReviewLeftComponentWrapDiv>
    <ReviewLeftComponentImageWrapDiv>
      <ReviewImageInnerWrapDiv></ReviewImageInnerWrapDiv>
    </ReviewLeftComponentImageWrapDiv>

    <ReviewRatingWrapDiv>
      <ReviewInnerWrapDiv>
        <NumberWrapSpan></NumberWrapSpan>
        <BarWrapSpan></BarWrapSpan>
        <NumberWrapSpan></NumberWrapSpan>
      </ReviewInnerWrapDiv>

      <ReviewInnerWrapDiv>
        <NumberWrapSpan></NumberWrapSpan>
        <BarWrapSpan></BarWrapSpan>
        <NumberWrapSpan></NumberWrapSpan>
      </ReviewInnerWrapDiv>

      <ReviewInnerWrapDiv>
        <NumberWrapSpan></NumberWrapSpan>
        <BarWrapSpan></BarWrapSpan>
        <NumberWrapSpan></NumberWrapSpan>
      </ReviewInnerWrapDiv>

      <ReviewInnerWrapDiv>
        <NumberWrapSpan></NumberWrapSpan>
        <BarWrapSpan></BarWrapSpan>
        <NumberWrapSpan></NumberWrapSpan>
      </ReviewInnerWrapDiv>

      <ReviewInnerWrapDiv>
        <NumberWrapSpan></NumberWrapSpan>
        <BarWrapSpan></BarWrapSpan>
        <NumberWrapSpan></NumberWrapSpan>
      </ReviewInnerWrapDiv>
    </ReviewRatingWrapDiv>
  </ReviewLeftComponentWrapDiv>
);

export default ReviewLeftComponent;

const ReviewLeftComponentWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  padding:${props.theme.spacing.large};

  width:50%;
  justify-content: space-between;


`,
);

const ReviewLeftComponentImageWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;

  width:30%;

`,
);

const ReviewImageInnerWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  margin-right:${props.theme.spacing.large};
  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius:${props.theme.misc.borderRadius.xlarge};
  width:14.5rem;
  height:16.5rem;

`,
);

const ReviewRatingWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  width:70%;

`,
);

const ReviewInnerWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items:center;
`,
);

const NumberWrapSpan = styled.span(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius:${props.theme.misc.borderRadius.small};
  width:3.8rem;
  height:2.2rem;


`,
);

const BarWrapSpan = styled.span(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius:${props.theme.misc.borderRadius.large};
  width:25.8rem;
  height:0.75rem;
  margin-right:${props.theme.spacing.large};
  margin-left:${props.theme.spacing.large};

`,
);
